import {createApp} from "vue"
import {createHead} from "@vueuse/head";
import router from "./router"
import App from "./App.vue"
import "./assets/tailwind.css"

const head = createHead()

createApp(App)
  .use(router)
  .use(head)
  .mount("#app")
